// @generated by web/tools/codegen — DO NOT EDIT

/**
 * The CLOSED page-chrome vocabulary — generated from the `PageChrome`
 * enum webroutesgen parses `web/manifests/routes.yaml`'s `chrome:` with,
 * so the union and the manifest cannot disagree.
 *
 * - `hub`: a root destination: navbar, footer (md+), bottom tabs (<md)
 * - `article`: a content page that owns its bottom edge: navbar + footer, no tabs
 * - `focus`: the page owns its bottom edge: navbar only, no footer, no tabs
 * - `inbox`: a tab root that is not a content page: navbar + bottom tabs, no footer
 * - `canvas`: a viewport-sized working surface (map + results): navbar full-bleed, no footer, no tabs - the page owns the rest of the viewport and does not scroll the document
 * - `flow`: no site chrome at all - the page owns the whole viewport
 *
 * `PageShell`'s table is `satisfies Record<PageChrome, ChromeSpec>`, so a
 * kind added to the manifest's vocabulary does not typecheck until the
 * shell says which bands it renders.
 */
export const PAGE_CHROME_KINDS = ['hub', 'article', 'focus', 'inbox', 'canvas', 'flow'] as const;

/** One of {@link PAGE_CHROME_KINDS}. */
export type PageChrome = (typeof PAGE_CHROME_KINDS)[number];

/**
 * Narrow a route match's `handle.chrome`. React Router types `handle`
 * as `unknown`, so the shell owns the narrowing — and a value outside
 * the vocabulary must THROW rather than default, because a default
 * renders some chrome for a route whose chrome nobody decided.
 */
export function isPageChrome(value: unknown): value is PageChrome {
  return (PAGE_CHROME_KINDS as readonly unknown[]).includes(value);
}

/**
 * The kinds whose pages render the MOBILE TOP BAND — and which the
 * generator therefore REQUIRES a `back:` route id from, on every node
 * that resolves to one.
 *
 * This is the generator's own predicate, emitted rather than restated:
 * `PageShell`'s `mobileHeader` column must be exactly this set, and
 * `PageShell.react.test.tsx` asserts it. A band the shell renders for a
 * kind the generator did not ask a target of is a back control pointing
 * nowhere; the reverse is a route asked for a target nothing reads.
 */
export const CHROME_KINDS_WITH_BACK_TARGET = ['article', 'focus'] as const;
